export default "__VITE_ASSET__BQFxcINE__"